import { advancedAdminControlsEntryPoint } from '@jira/admin-pages__advanced-admin-controls/src/advancedAdminControlsEntryPoint.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { advancedAdminControlsRoute } from '@atlassian/jira-router-routes-admin-pages-advanced-admin-controls-routes/src/advancedAdminControlsRoute.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const advancedAdminControlsEntryPointPage = createPageEntryPoint({
	main: advancedAdminControlsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const advancedAdminControlsRouteEntry: Route = createEntry(
	advancedAdminControlsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'advanced-admin-controls',
		component: ErrorPagesNotFound,
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsSystem,
		},
		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],
		entryPoint: () => {
			if (!fg('jira_advanced_admin_controls_fg')) {
				return undefined;
			}

			if (expValEquals('jira_advanced_admin_controls', 'cohort', 'treatment', 'not-enrolled')) {
				return advancedAdminControlsEntryPointPage;
			}
		},
		canTransitionIn: () =>
			!!expValEquals('jira_advanced_admin_controls', 'cohort', 'treatment', 'not-enrolled'),
		forPaint: [LazyAtlassianNavigation],
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-advanced-admin-controls-entries/src/advancedAdminControlsRouteEntry.tsx',
				whichExportToUse: 'advancedAdminControlsRouteEntry',
			},
			enabled: true,
		},
	}),
);
